// extracted by mini-css-extract-plugin
export default {"container":"GlossaryEntry_container__2b3a5","word":"GlossaryEntry_word__nSzeU","definition":"GlossaryEntry_definition__q4wLX"};